export default __webpack_public_path__ + "static/media/Letters3_13.57f02295.png";